/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import headerConfig from "../config/header.config.json";
import footerConfig from "../config/footer.config.json";
import bodyTitleConfig from "../config/bodyTitle.config.json";
import policyOptionsConfig from "../config/policyOptions.config.json";
import rightBlockConfig from "../config/rightBlock.config.json";
import selectCountryConfig from "../config/selectCountry.config.json";
import kycformConfig from "../config/kycform.config.json";
import termsOfUseConfig from "../config/termsOfUse.config.json";
import emailKycConfig from "../config/emailField.condig.json";
import policyStatusConfig from "../config/policyStatus.config.json";
import loadingConfig from "../config/loading.config.json";
import intendedPurposeConfig from "../config/intendedPurpose.config.json";
import errorConfig from "../config/error.config.json";
import offerConfig from "../config/offer.config.json";
import { VApplication } from "../../../application";
import { BreadcrumbService } from "../../breadcrumbService";
import policyPayoutHeaderConfig from "../config/policyPayoutHeader.config.json";
import notificationConfig from "../config/notifications.config.json";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      ...headerConfig,
      ...footerConfig,
      bodyTitle: bodyTitleConfig,
      rightBlockContent: rightBlockConfig,
      policyOptions: policyOptionsConfig?.options,
      selectCountryConfig: selectCountryConfig,
      kycFormConfig: kycformConfig,
      emailKyc: emailKycConfig,
      termsOfUseContent: termsOfUseConfig,
      policyStatus: policyStatusConfig,
      intendedPurpose: intendedPurposeConfig,
      policyPayoutHeaders: policyPayoutHeaderConfig,
      loading: loadingConfig,
      error: errorConfig,
      notification: notificationConfig,
      offer: offerConfig?.offerImage,
    };
  }
}
